import * as React from "react"

const Tooltip = ({total, quantity}) => (
  <div  className="item-available mgt-10">
  <div  className="available">
      <span  className="color_width" data-title={+total-quantity} data-toggle='tooltip' style={{width: (quantity/total)*100 }}></span>
  </div>
  <img className="image-animation" style={{left: (quantity/total)*100-15 }} src="/images/product_detail/fire.png" alt="icon"></img>
  <p  className="a2">Còn {quantity} sản phẩm</p>
</div>
)

export default Tooltip
